<template>
  <v-container>
    <h2 class="primary--text">Welcome to TAP</h2>
    <br />
    <p>
      Thank you for signing up with Ordertrainings. Trainer's APP is a tool that helps trainers to stay prepared for the future. Our data driven platform shall cater to your array of needs and requirements. You will find suitable opportunities and palatable matches all at one place, programmatically sorted to meet your expectations.
    </p>
    <div style="font-size: 20px; text-align: center;"><strong>Just follow simple steps to fill up your information and get started</strong></div>
    <br />
    <div>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md8>
          <v-img
            contain
            :src="`/static/img/present.png`"
            :lazy-src="`/static/img/present.png`"
            aspect-ratio="1"
            height="200px"
            width="100%"

          >
            <v-layout
              slot="placeholder"
              fill-height
              align-center
              justify-center
              ma-0
            >
              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            </v-layout>
          </v-img>
        </v-flex>
      </v-layout>
    </div>
    <div style="font-size: 16px;">
      <strong>Here are a few points to start with</strong>
    </div>
    <ul>
      <li>
        Provides recommendations personalized for your profile.
      </li>
      <li>
        Helps you create training programs that are high on demand in the industry.
      </li>
      <li>
        Collects feedback of your trainings at one place and helps you become more confident in your niche.
      </li>
      <li>
        Provides calendar to manage your schedule more efficiently, and also syncs with your existing calendar. <br />
        - Calendar feature helps capturing the opportunities much faster.
      </li>
      <li>
        Provides more localised opportunities, and hence reduces hectic travelling.
      </li>
      <li>
        Guarantees training opportunities for every trainer with a complete profile<br />
        - Completing TAP format profile 100% <br/>
        - Selling TAP recommended Programs*
      </li>
    </ul>
    <!-- <div style="font-size: 20px; text-align: center;" >Just follow simple steps to fill up your information and get started</div>
    <br />
    <div>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md8>
          <v-img
            contain
            :src="`/static/img/present.png`"
            :lazy-src="`/static/img/present.png`"
            aspect-ratio="1"
            height="200px"
            width="100%"

          >
            <v-layout
              slot="placeholder"
              fill-height
              align-center
              justify-center
              ma-0
            >
              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            </v-layout>
          </v-img>
        </v-flex>
      </v-layout>
    </div> -->
    <br/>
    <div class="text-xs-center">
      <v-btn to="/profile-completion" color="primary" round>Start creating your profile</v-btn>
    </div>
  </v-container>
</template>
<script>
export default {
  name: 'Welcome',
  beforeCreate () {
    if (this.$store.state.user.completion > 7) {
      this.$router.push('/profile-completion')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Welcome.vue